import React from 'react';

import {
  Box,
  BoxProps,
} from '@waglabs/box-next';

type Props = BoxProps;
export const CardContent = ({
  children,
  px = '48px',
  ...others
}: Props) => (
  <Box
    px={px}
    {...others}
  >
    {children}
  </Box>
);
